import CollectionPlayer from "@/employee/CollectionPlayer"
import util from "@/util"
import { identifier, list, map, primitive, serializable } from "serializr"

export default class ValueMod {
  @serializable(identifier())
  public readonly uuid: string = util.uuid()
  @serializable
  public readonly type: string = 'add' // add, mul
  @serializable
  public readonly value: number = 0

  constructor(value: number, type: string) {
    this.type = type
    this.value = value
  }

  static activate(value: number, mod: ValueMod): number {
    if (mod.type === 'add') return value + mod.value
    else if (mod.type === 'mul') return value * mod.value

    return value
  }

  /**
   * Returns the value that could be activated to become X, where X is the input value
   * @param value X
   * @param mod
   */
  static reverseActivate(value: number, mod: ValueMod): number {
    if (mod.type === 'add') return value - mod.value
    else if (mod.type === 'mul') return value * (1 / mod.value)
    return value
  }

  /**
   * Activate all mods on a value. This uses a predefined order of activation.
   * @param value the value to modify
   * @param mods
   */
  static activateAll(value: number, mods: ValueMod[]): number {
    for (let mod of mods) {
      if (mod.type === 'add') value = ValueMod.activate(value, mod)
    }

    for (let mod of mods) {
      if (mod.type === 'mul') value = ValueMod.activate(value, mod)
    }

    return value
  }

  /**
   * Reverse-activates all mods on a value. This uses a predefined order of activation.
   * @param value the value to modify
   * @param mods
   */
  static reverseActivateAll(value: number, mods: ValueMod[]): number {
    for (let mod of mods.reverse()) {
      if (mod.type === 'mul') value = ValueMod.reverseActivate(value, mod)
    }

    for (let mod of mods.reverse()) {
      if (mod.type === 'add') value = ValueMod.reverseActivate(value, mod)
    }

    return value
  }

  equals(mod: ValueMod) {
    return this.value == mod.value && this.type == mod.type
  }

  toString(): string {
    let s = ""
    let value = util.showNumber(Math.abs(this.value))
    let type = ""
    if (this.type === 'add') {
      if (this.value > 0) s = `+${value}`
      else s = `-${value}`
    } else if (this.type === 'mul') {
      s = `x${value}`
    }
    return s
  }
}
